import { render, staticRenderFns } from "./CustomerContactTypeTranslationEditPopup.vue?vue&type=template&id=222cb215&"
import script from "./CustomerContactTypeTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerContactTypeTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports